module.exports = {"500118001":"中山路街道","500118002":"胜利路街道","500118003":"南大街街道","500118004":"茶山竹海街道","500118005":"大安街道","500118006":"陈食街道","500118007":"卫星湖街道","500118100":"青峰镇","500118102":"金龙镇","500118104":"临江镇","500118106":"何埂镇","500118107":"松溉镇","500118108":"仙龙镇","500118109":"吉安镇","500118110":"五间镇","500118111":"来苏镇","500118112":"宝峰镇","500118113":"双石镇","500118114":"红炉镇","500118115":"永荣镇","500118116":"三教镇","500118117":"板桥镇","500118118":"朱沱镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500118.json
// module id = 2052
// module chunks = 0